import { Typography } from "@material-ui/core";
import { Tabs } from "antd";
import { selectCurrentUser } from "features/auth/authSlice";
import EmandiReports from "features/E-Mandi/EmandiReport/emandiReport";
import { Mandi } from "features/E-Mandi/EmandiReport/Mandi";
import { useGetDashboardProfilebyIdQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import FarmerList from "features/onboarding/users/farmer/FarmerList";
import EmployeesList from "features/userManagement/EmployeesList";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { CardBody } from "reactstrap";
import FPOList from "features/onboarding/organizations/FarmersGroup/FPO/FPOList";
import { AggregationParent } from "components/Aggregation/AggregationParent";
import ClusterMap from "../OrganizationDashboard/ClusterMap";
import { Box, Card, CardContent, Grid } from "@mui/material";
import { Spin } from "antd"; // Ant Design spinner for loading
import { store } from "app/store";
import { API_URL } from "app/config";
import { FieldActivities } from "./FieldActivities";

const ProjectProfileDashboardById = ({ activeCards, activeProjects }) => {
  const currentUser = useSelector(selectCurrentUser);
  const RoleAcessParams = currentUser?.realm_access?.roles;
  const { id } = useParams();
  const location = useLocation();
  const isCBBO = location.pathname.includes("CBBO");
  const { data: userProfile, isLoading } = useGetDashboardProfilebyIdQuery(id); // destructure isLoading
  const [apiData, setApiData] = useState([]);
  const [mandiCard, setMandiCard] = useState({
    total: "",
    sum: "",
    totalQuantity: 0,
  });
  // console.log("all active project",activeProjects)
  useEffect(() => {
    if (userProfile) {
      setApiData(userProfile?.data);
    }
  }, [userProfile]);
  const fetchMandiData = async () => {
    try {
      const state = store.getState();
      const response = await fetch(
        `${API_URL}/api/v1/onboarding/farmer-aggrigation?organization_id=${id}`,

        {
          headers: { authorization: `Bearer ${state.auth.accessToken}` },
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();

      const filteredData = data?.data?.filter(
        (item) => item.current_status === "Procurement Done"
      );

      const totalQuantity = filteredData?.reduce((sum, item) => {
        let quantity = Number(item.quantity || 0);
        if (item.unit_of_quantity === "Quintals") quantity *= 100;
        return sum + quantity;
      }, 0);

      setMandiCard({
        total: data?.data || [],
        totalQuantity,
      });
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };
  useEffect(() => {
    fetchMandiData();
  }, []);
  const project = apiData?.organization_details?.project || null;

  const allTabs = {
    Farmers: {
      key: "Farmers",

      label: "Farmers",
      // children: <FarmerList showMap={false} projectExist={activeProjects} />,
      children: <FarmerList showMap={false} projectExist={project} />,
    },
    "Field Activities": {
      key: "Field Actitities",
      label: "Field Activities",
      children: <FieldActivities />,
    },
    "Cluster Map": {
      key: "Cluster Map",
      label: "Cluster Map",
      children: (
        <Card style={{ height: "90svh" }}>
          <CardBody className="p-1 p-lg-3">
            <ClusterMap />
          </CardBody>
        </Card>
      ),
    },
    "E-Mandi": {
      key: "E-Mandi",
      label: "E-Mandi",
      children: <Mandi isHCL />,
    },
    "Live Mandi Prices": {
      key: "Live Mandi Prices",
      label: "Live Mandi Prices",
      children: <EmandiReports isHCL />,
    },
    Aggregation: {
      key: "Aggregation",
      label: "Aggregation",
      children: <AggregationParent crops={apiData?.crops_dealing} />,
    },
    Employees: {
      key: "Employees",
      label: "Employees",
      children: <EmployeesList />,
    },
  };

  let tabItems = [];

  if (isLoading) {
    return (
      <div className="text-center mt-5">
        <Spin size="large" />
      </div>
    );
  }

  if (
    apiData?.organization_details?.project &&
    apiData?.organization_details?.project?.modules &&
    Object.keys(apiData?.organization_details?.project?.modules).length > 0
  ) {
    tabItems = Object.keys(allTabs)
      .map((key) => {
        const tab = Object.keys(
          apiData?.organization_details?.project?.modules
        ).includes(key)
          ? allTabs[key]
          : null;
        if (!tab) return null;
        return {
          ...tab,
          label: apiData?.organization_details?.project?.modules[key],
        };
      })
      .filter(Boolean);
  } else if (isCBBO) {
    tabItems = [
      allTabs["FPO"],
      allTabs["Farmers"],
      allTabs["E-Mandi"],
      allTabs["Live Mandi Prices"],
    ];
  } else {
    tabItems = [
      allTabs["Farmers"],
      allTabs["E-Mandi"],
      allTabs["Live Mandi Prices"],
      allTabs["Employees"],
      allTabs["Aggregation"],
    ];
  }
  const hasEMandiTab = tabItems?.some(
    (item) => item.key === "E-Mandi" || item.label === "E-Mandi"
  );
  const hasEMandiCard = activeCards?.some((card) => card.title === "E-Mandi");

  let cards = activeCards
    .filter((card) => card.title !== "FPO")
    .map((card) => {
      let updatedTotal = card.total;

      switch (card.title) {
        case "Farmers":
          updatedTotal = apiData?.total_customers ?? 0;
          break;
        case "Land Holding":
          updatedTotal = apiData?.land_holding ?? 0;
          break;
        case "Crops":
          updatedTotal = apiData?.crops_dealing?.length ?? 0;
          break;
        case "Employees":
          updatedTotal = apiData?.total_employees ?? 0;
          break;
        case "E-Mandi":
          updatedTotal = mandiCard?.total?.length ?? 0;
          break;
        default:
          updatedTotal = card.total;
      }

      return {
        ...card,
        total: updatedTotal,
        totalProcure: card.totalProcure,
      };
    });

  if (hasEMandiTab && !hasEMandiCard) {
    cards.push({
      title: "E-Mandi",
      icon: "https://cdn-icons-png.flaticon.com/512/4866/4866817.png",

      total: mandiCard?.total?.length ?? 0,
      totalProcure: 0,
    });
  }

  const colSize = cards.length >= 5 ? "calc(20% - 16px)" : "calc(25% - 16px)";
  const rightBorderColors = ["#FFBF69", "#64e9e9", "#BDB2FF", "#FFD6A5"];
  return (
    <div className="p-1">
      <div className="cards-grid">
        {cards.map((item, index) => (
          <Card
            key={index}
            onClick={item.action}
            style={{
              cursor: item.action ? "pointer" : "default",
              background: "#fff",
              marginBottom: "0px",
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              transition: "all 0.3s ease-in-out",
              borderRight: `3px solid ${
                rightBorderColors[index % rightBorderColors.length]
              }`,
            }}
            onMouseEnter={(e) => {
              if (item.action) {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow =
                  "0 8px 20px rgba(199, 110, 0, 0.25)";
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
            }}
            className="mt-3"
          >
            <CardContent style={{ padding: "24px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "1rem",
                }}
              >
                <Typography variant="h5" style={{ fontWeight: "600" }}>
                  {item.title}
                </Typography>
                <img
                  src={item.icon}
                  alt={item.title}
                  style={{
                    width: "32px",
                    height: "32px",
                    objectFit: "contain",
                  }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center  gap-5">
                <Typography
                  variant="body1"
                  style={{ color: "#555", fontWeight: "500" }}
                >
                  Total
                </Typography>
                <Typography
                  variant="h3"
                  style={{ color: "#006EB7", fontWeight: "700" }}
                >
                  {item.total}
                </Typography>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="mt-3">
        <Tabs items={tabItems} />
      </div>
    </div>
  );
};
export default ProjectProfileDashboardById;
